<template>
  <span v-if="state === 'free'" style="width: 15px" />
  <div v-else :style="{width: '15px', height: '15px'}" class="splicing-icon-container">
    <v-icon
      :class="className"
      :size="size"
      :style="{ transform: state === 'split' ? 'rotate(180deg)' : 'unset', color: color ? color : null}"
    >
      {{ icon }}
    </v-icon>
  </div>
</template>

<script>
export default {
  name: "ConnectionPointConnectionIcon",

  props: {
    state: String,
    side: String,
    connectionType: String,
  },
  data() {
    return {
      size: 15,
      color: null,
      className: null
    };
  },
  computed: {
    icon() {
      this.color = this.connectionType === 'CONNECTOR' ? 'darkorange' : 'green';
      if (this.state === "connected" && this.side === "origin") {
        this.size = 12;
        return "circle";
      }else if(this.state === "connected" && this.side === "destination"){
        this.size = 15;
        return "play_arrow";
      } else if(this.side === "origin" && this.state === "split"){
        return "close";
      } else if (this.state === "occupied") {
        return "close";
      } else if (this.state === "split") {
        return "play_arrow";
      } else if (this.state === "in" && this.side === "origin") {
        this.size = 16;
        this.className = 'rotate'
        return "play_arrow";
      } else if (this.state === "in" && this.side === "destination") {
        this.size = 15;
        return "play_arrow";
      }
      return null;
    }
  }
};
</script>
<style scoped>
.splicing-icon-container{
  display: flex;
  align-items: flex-start !important;
  justify-content: flex-end !important;
}
.rotate{
  transform: rotateZ(-180deg) !important;
}
</style>


// WEBPACK FOOTER //
// src/components/Home/Forms/_SpecialTabs/Splicing/ObjectTable/ConnectionPointConnectionIcon.vue